export const TRANSLATIONS_MR = {
  login: {
    welcome: "स्वागत आहे",
    username: "वापरकर्तानाव",
    password: "पासवर्ड",
    usernamePlaceholder: "नोंदणीकृत ईमेल / वापरकर्तानाव",
    signIn: "साइन इन करा",
    forgotPassword: "पासवर्ड विसरलात",
    noAccount: "खाते नाही?",
    registerNow: "अाता नोंदणी करा",
    noUsername: "कृपया तुमचे वापरकर्तानाव इनपुट करा!",
    noPassword: "कृपया तुमचा पासवर्ड इनपुट करा!",
  },
  register: {
    newUser: "नवीन वापरकर्ता",
    registerHere: "येथे नोंदणी करा",
    email: "ईमेल",
    emailPlaceholder: "तुमचा नोंदणीकृत ईमेल टाका",
    mobileNo: "मोबाईल क्र",
    createPassword: "पासवर्ड तयार करा",
    confirmPassword: "पासवर्डची पुष्टी करा",
    passwordAgain: "पुन्हा पासवर्ड टाइप करा",
    mobilePlease: "कृपया मोबाईल नंबर",
    signUp: "साइन अप करा",
    alreadyHaveAccount: "आधीपासूनच एक खाते आहे!",
    signIn: "साइन इन करा",
    noMobileNo: "कृपया तुमचा मोबाईल नंबर प्रविष्ट करा!",
    noEmail: "कृपया तुमचा ईमेल इनपुट करा!",
    noPassword: "कृपया तुमचा पासवर्ड इनपुट करा!",
    noConfirmPassword: "कृपया तुमचा पुष्टी संकेतशब्द प्रविष्ट करा!",
  },
  verify: {
    title: "OTP सह पडताळणी करा",
    otpOn: "आम्ही वर एक OTP पाठवला आहे",
    registeredEmail: "आणि तुमचा नोंदणीकृत ईमेल पत्ता",
    codeNotReceived: "मला कोड मिळाला नाही.",
    resend: "पुन्हा पाठवा",
    itOr: "ते किंवा",
    details: "तपशील",
    changeRegistrationDetails: "नोंदणी तपशील बदला",
    verify: "सत्यापित करा",
  },
};
